var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 145 144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.122 110.45-0.1659-12.028c14.321-0.7172 20.293 2.4825 28.366 11.862l-28.2 0.166zm-25.657 0.055c2.6541-7.338 12.22-10.814 19.961-11.697l0.1659 11.587-20.127 0.11zm62.759-0.11c-12.662-17.05-22.892-20.084-41.029-18.594-27.481 2.0415-32.513 14.952-32.181 37.794v0.166c0.055295 1.876 1.5483 3.421 3.4836 3.421l4.9765-0.055c0.33176-6.677 5.8059-12.029 12.607-12.084 6.8566-0.055 12.441 5.242 12.994 11.918l21.067-0.11c0.3317-6.676 5.8059-12.028 12.607-12.084 6.8566-0.055 12.441 5.242 12.994 11.918h3.8707c1.9353 0 3.4282-1.6 3.4282-3.421-0.0553-4.579 1.493-13.186-14.819-18.869zm-7.3542 25.877c-1.3823-1.159-1.6035-3.145-0.4976-4.525 1.1059-1.379 3.1518-1.545 4.5341-0.441 1.3824 1.159 1.6036 3.145 0.4977 4.524-1.1059 1.38-3.1518 1.545-4.5342 0.442zm7.9624-9.711c-4.0365-3.311-9.953-2.759-13.215 1.269-3.2623 3.972-2.6541 9.876 1.3824 13.187 4.0365 3.31 9.953 2.758 13.215-1.269 3.2624-3.973 2.5988-9.877-1.3824-13.187zm-54.52 9.876c-1.3823-1.159-1.6035-3.145-0.4976-4.524 1.1059-1.38 3.1518-1.545 4.5341-0.442 1.3824 1.159 1.6036 3.145 0.4977 4.525-1.1059 1.434-3.1518 1.6-4.5342 0.441zm7.9624-9.656c-4.0365-3.31-9.953-2.758-13.215 1.27-3.2623 3.972-2.6541 9.876 1.3824 13.186 4.0365 3.311 9.953 2.759 13.215-1.269 3.2624-4.027 2.5988-9.931-1.3824-13.187z",
    fill: "#0000C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.017 72.624h-36.494v-13.794l56.953-56.83 63.036 63.451v70.073l-36.671 0.358",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 16,
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m77.375 66.83v2.8139h2.1012c0.3871 0 0.7188 0.3311 0.7188 0.7173 0 0.3863-0.3317 0.7173-0.7188 0.7173h-2.1012v2.8139h2.1012c0.3871 0 0.7188 0.3311 0.7188 0.7173s-0.3317 0.7173-0.7188 0.7173h-2.1012v2.8139h4.2577v-11.256h-4.2577v-0.0552zm0-2.8139h4.2577c1.5482 0 2.82 1.269 2.82 2.8139v11.256c0 1.5449-1.2718 2.814-2.82 2.814h-4.2577c0 0.7724-0.6082 1.4345-1.4377 1.4345h-6.6353c-0.2765 0-0.5529-0.1103-0.7741-0.2207l-8.1283-3.9726h-2.82c-0.7742 0-1.4377-0.6069-1.4377-1.4345v-8.4418c0-0.7725 0.6082-1.4346 1.4377-1.4346h2.82l8.1283-3.9726c0.2212-0.1655 0.4976-0.2207 0.7741-0.2207h6.6353c0.7742 0 1.4377 0.6069 1.4377 1.3794z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 82.386,
    x2: 82.386,
    y1: 8.0448,
    y2: 131.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 70.266,
    x2: 70.266,
    y1: 63.526,
    y2: 81.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateCar);
export default __webpack_public_path__ + "static/media/privateCar.f9dc66c25a9c13537127f8e2c9697cc1.svg";
export { ForwardRef as ReactComponent };